import characters from "./characters";
import { Entity, Game, GameFlow, SectionType } from "./types";


export const devLevel: GameFlow = [

    {
        type: SectionType.INTERLUDE,
        screens: [
            {text: {t: "Hello James... "}},
            {text: {t: "... "}},
            {text: {t: " James... "}},
            {text: {t: " Wake up James... "}},
            {
                image: '/resources/welcomeToTwinPeaks.jpg', 
                maxDuration: 2000
            },
            {
                image: '/resources/welcomeToTwinPeaks.jpg', 
                maxDuration: 2000,
                npcDialog: {
                    person: characters.Cooper,
                    dialog: "Welcome James. It's damn good to see you."
                }
            },

            {
                image: '/resources/welcomeToTwinPeaks.jpg', 
                maxDuration: 2000,
                npcDialog: {
                    person: characters.Cooper,
                    dialog: "I have a mission for you James. It's absolutely vital that you listen closely."
                }
            },
            {
                image: '/resources/welcomeToTwinPeaks.jpg', 
                maxDuration: 2000,
                npcDialog: {
                    person: characters.Pie,
                    dialog: "Come 'ere big boy"
                }
            },
            {
                image: '/resources/welcomeToTwinPeaks.jpg', 
                maxDuration: 2000,
                npcDialog: {
                    person: characters.Cooper,
                    dialog: "I'm sorry James... that mission will have to wait."
                }
            },
            {
                image: 'https://i.pinimg.com/originals/94/f6/18/94f6184fd7444cd29ad1793b953f47a5.gif', 
                maxDuration: 2000,
                npcDialog: {
                    person: characters.James,
                    dialog: "It's okay. In the meantime, I'll be......"
                }
            },
            {text: {t: "Pt 1: Looking For Love <3", style: "LevelTitle"}},

            

            //... would be cool to have discussions possible
        ],
        music: "/audio/twinPeaksTheme.mp3"
    },
    {
        type: SectionType.INTERLUDE,
        screens: [
            {
                image: "https://www.seanmichaelragan.com/img/twin_peaks_bird.jpg",
            },
            {
                image: "https://img.freepik.com/premium-photo/room-with-guitar-poster-wall-that-says-word-it_960764-6050.jpg",
                npcDialog: {
                    person: characters.BigEd,
                    dialog: "Hey Jimbo. Morning to ya."
                }
            },
            {
                image: "https://img.freepik.com/premium-photo/room-with-guitar-poster-wall-that-says-word-it_960764-6050.jpg",
                npcDialog: {
                    person: characters.James,
                    dialog: "Omfg, please piss off"
                }
            },
            {
                npcDialog: {
                    person: characters.James,
                    dialog: "Ugh, jeesus christ, wtf."
                }
            },
            {
                image: "https://m.media-amazon.com/images/I/61GDKZUAkaL._AC_UF894,1000_QL80_.jpg",
            },
            {
                image: "https://m.media-amazon.com/images/I/61GDKZUAkaL._AC_UF894,1000_QL80_.jpg",
                npcDialog: {
                    person: characters.James,
                    dialog: "Damn baby,"
                }
            },
            {
                image: "https://m.media-amazon.com/images/I/61GDKZUAkaL._AC_UF894,1000_QL80_.jpg",
                npcDialog: {
                    person: characters.James,
                    dialog: "My aloe is looking tight as hell this morning."
                }
            },
            {
                image: "https://m.media-amazon.com/images/I/61GDKZUAkaL._AC_UF894,1000_QL80_.jpg",
                npcDialog: {
                    person: characters.James,
                    dialog: "Namaste and all that"
                }
            },
            {
                image: "https://m.media-amazon.com/images/I/61GDKZUAkaL._AC_UF894,1000_QL80_.jpg",
                npcDialog: {
                    person: characters.James,
                    dialog: "Anyways, I should go to school so Ed will piss of."
                }
            },
        ]
    },
    {
        type: SectionType.INTERLUDE,
        music: '/audio/JustYouOld.mp3',
        screens: [
            {
                image: "https://retouchingcentral.com/wp-content/uploads/2019/03/matrix-10.gif",
                npcDialog: {
                    person: characters.JamesGuyFierie,
                    dialog: "Hello. My name is James Guy Fierie."
                }
            },
            // TODO: Would be cool if the dialog boxes typed quickly
            {
                image: "https://retouchingcentral.com/wp-content/uploads/2019/03/matrix-10.gif",
                npcDialog: {
                    person: characters.JamesGuyFierie,
                    dialog: "This is not part of the website. I'm in charge now."
                }
            },
            {
                image: "https://encrypted-tbn3.gstatic.com/licensed-image?q=tbn:ANd9GcT2xT7b1vWaZTfMAHqTaVf8H5MnYkECnp9s4slhh8JJrAssBq25MU-TlvaHGh2zsidQ92tB1CgGigzJaDA",
                npcDialog: {
                    person: characters.JamesGuyFierie,
                    dialog: "Do you know who this is?"
                },
                input: {
                    placeholder: "Who is it?",
                    answer: "Robert Eggers"
                },
            },
            // {
            //     image: "https://encrypted-tbn3.gstatic.com/licensed-image?q=tbn:ANd9GcT2xT7b1vWaZTfMAHqTaVf8H5MnYkECnp9s4slhh8JJrAssBq25MU-TlvaHGh2zsidQ92tB1CgGigzJaDA",
            //     npcDialog: {
            //         person: characters.JamesGuyFierie,
            //         dialog: "This man is a genius. We're going to find him."
            //     }
            // },
            {
                image: 'https://media.giphy.com/media/l1IY2yT4fAo66oDPG/giphy.gif',
                text: {t: "Donna..."}
            },
            {
                image: 'https://media.giphy.com/media/l1IY2yT4fAo66oDPG/giphy.gif',
                text: {t: "I wish i was not so weak..."}
            }
        ]
    },

]

export const searchingForLove: Game = {
    name: 'searching for love',
    link: 'searching_for_love',
    gameFlow: devLevel
}